import { connect } from 'react-redux';
import MobileDrawer from './MobileDrawer';
import { setMobileDrawerOpen } from './store/mobileDrawerSlice';
import { getFilterIdentifierCount } from '../filters/store/filtersSlice';

const mapState = state => ({
  filterIdentifierCount: getFilterIdentifierCount(state),
  mobileDrawerOpen: state.loadingManagement.mobileDrawer.mobileDrawerOpen,
});

const mapDispatch = {
  setMobileDrawerOpen,
};

export default connect(mapState, mapDispatch)(MobileDrawer);
